import React from 'react'

export const CustomerAccountContext = React.createContext({})
